export const roundUpToNearestHalf = (price: number): number =>
  Math.ceil(price * 2) / 2;
